export type SideNavLinkConfig = {
  name: string;
  pathname: string;
  search?: string;
  exact?: boolean;
  hash?: string;
};

export type SideNavSectionConfig = {
  header: string;
  links: (SideNavLinkConfig | SideNavSectionConfig)[];
};

export enum SideNavStyle {
  normal = 'normal',
  nested = 'nested',
}
